import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";
import { functionDisplay } from '@devexpress/analytics-core/analytics-widgets-internal';
import { FunctionOperatorType } from '@devexpress/analytics-core/analytics-criteria';

export default {
  name: 'Schedule',
  mixins: [validationMixin],
  components: {
    datetime: Datetime,
    DateTime,
  },
  props: ['dataObj'],
  data: function () {
    return {
      suppServiceTypeId: -1,
      perEnd: '',
      perBegin: '',
      schedule: {
        activityId: 0,
        applicationId: 0,
        comment: '',
        supportService: '',
        supportServiceId: 0,
        supportServiceType: '',
        supportServiceTypeId: 0,
        id: 0,
        isMultiple: false,
        periodBegin: moment(new Date()).format(),
        periodDate: moment(new Date()).format(),
        periodDuration: '',
        periodEnd: moment(new Date()).format(),
        periodType: '',
        periodTypeId: 0,
        selection: [],
        readOnly: false,
        usageType: '',
        usageTypeId: 0,
        uuid: '',
        schedulesPeriodBegin: moment(new Date()).format(),
        schedulesPeriodEnd: moment(new Date()).format(),
      },
      supportService: {
        id: -1,
        name: '',
        rateHr: 0,
        station: '',
        stationId: -1,
        supportServiceType: '',
        supportServiceTypeId: -1,
        team: '',
        teamId: -1
      },
      supportServices: [],
      supportServicesAll: [],
      supportServiceTypes: [],
      teams: [],
      team: { text: 'All', value: '-1' },
      teamId: -1,
      stations: [],
      station: { text: '', value: '' },
      stationId: -1,
      usageTypes: [],
      periodTypes: [],
      bWholeDay: false,
      selection: [],
    }
  },
  computed: {
    selectionCount: function () {
      return this.selection.length;
    },
    rateTypeId: function () {
      return this.schedule.rateTypeId;
    }
  },
  validations: {
    employee: {
      required
    },
    rateType: {
      required
    },
    usageType: {
      required
    },
    supportServiceType: {
      required
    },
  },
  watch: {
    bWholeDay: function (value) {
      this.dataObj.periodTypeId = value === true ? 2 : 1;
      this.dataObj.periodType = this.dataObj.periodTypes.filter(p => p.value == this.dataObj.periodTypeId)[0].text;
    },
    team: function (value) {
      if (!value)
        return;
      this.teamId = parseInt(value.value);
      this.filterSupportServices();
    },
    station: function (value) {
      if (!value)
        return;
      this.dataObj.stationId = value.value;
      this.stationId = parseInt(value.value);

      this.filterSupportServices();
    },
    supportServiceType: function (value) {
      if (!value)
        return;
      this.dataObj.supportServiceTypeId = value.value;
      this.filterSupportServices();
    },
    supportService: function (value) {
      if (!value)
        return;
      //console.log("suport service", value);
      this.dataObj.supportServiceId = value.id;
      this.dataObj.supportService = value.name;
      this.dataObj.supportServiceTypeId = value.supportServiceTypeId;
      this.dataObj.supportServiceType = value.supportServiceType;
    },
    selectionCount: function (value) {
      //console.log("sel count", this.selection);
      this.dataObj.selection = [];
      if (value === 0) 
        return;
      this.selection.forEach(p => this.dataObj.selection.push({ id: p.id, typeId: p.supportServiceTypeId, name: p.name}));
    },
    suppServiceTypeId: function (val) {
      if (val == null)
        return;
      ;
      this.schedule.supportServiceTypeId = parseInt(val);
      //reset other categories
      this.selection = '';
      this.supportService = '';
      this.dataObj.supportServiceId = '';
      this.dataObj.supportService = '';
    },
    perBegin: function (val) {

      this.schedule.periodBegin = val;
      this.calculateDuration();
    },
    perEnd: function (val) {
      this.schedule.periodEnd = val;
      this.calculateDuration();
    },
    
  },
  created() {
    this.init();
  },
  methods: {
    calculateDuration() {
      //if (!this.schedule.periodBegin || !this.schedule.periodEnd)

      //find difference and convert it to mins
      //create new dates with hours/mins on current date to avoid any mistakes in calulation by user inputing time in different days
      let start = new Date(this.schedule.periodBegin);
      let end = new Date(this.schedule.periodEnd);
      let now = new Date();

      let startNow = now.setHours(start.getHours(), start.getMinutes());
      let endNow = now.setHours(end.getHours(), end.getMinutes());

      let t = (endNow - startNow) / 1000 / 60;
      this.schedule.periodDuration = t.toString();
      //console.log("start",this.schedule.periodBegin , "end",this.schedule.periodEnd , "duration",this.schedule.periodDuration);
    },
    init() {
      Vue.nextTick(() => {
        this.schedule = this.dataObj;
        this.stationId = this.dataObj.stationId;
        this.stations = this.dataObj.stations;
        this.teams = this.dataObj.teams;

        this.periodTypes = this.dataObj.periodTypes;
        this.periodTypes = this.dataObj.periodTypes;
        if (this.schedule.isMultiple === true) {
          this.schedule.periodTypeId = this.periodTypes.filter(p => p.selected === true)[0].value;
          this.schedule.periodType = this.periodTypes.filter(p => p.value === this.schedule.periodTypeId)[0].text;
        }
        
        this.usageTypes = this.dataObj.usageTypes;
        if (this.schedule.isMultiple === true) {
          this.schedule.usageTypeId = this.usageTypes.filter(p => p.selected === true)[0].value;
          this.schedule.usageType = this.usageTypes.filter(p => p.value === this.schedule.usageTypeId)[0].text;
        }
        
        this.supportServiceTypes = this.dataObj.supportServiceTypes;
        if (this.schedule.isMultiple === true) {
          this.schedule.supportServiceTypeId = this.dataObj.supportServiceTypes.filter(p => p.selected === true)[0].value;
          this.schedule.supportServiceType = this.dataObj.supportServiceTypes.filter(p => p.value === this.schedule.supportServiceTypeId)[0].text;
        }
        else {
          this.supportService.name = this.dataObj.supportService;
          this.supportService.id = this.dataObj.supportServiceId;
        }
                
        this.supportServices = this.dataObj.supportServices;
        this.supportServicesAll = this.dataObj.supportServices;
        if (this.supportServices.filter(p => p.id === this.dataObj.supportServiceId) && this.supportServices.filter(p => p.id === this.dataObj.supportServiceId).length > 0)
          this.supportServices = this.supportServices .filter(p => p.id === this.dataObj.supportServiceId)[0];

        this.filterSupportServices();

        this.station = this.stations.filter(p => parseInt(p.value) == this.stationId)[0];
        if (this.dataObj.periodTypeId === 2) {
          this.bWholeDay = true;
        } else
          this.bWholeDay = false;
        let now = moment().format();
        this.perBegin = this.schedule.periodBegin != null ? this.schedule.periodBegin : now;
        this.perEnd = this.schedule.periodEnd != null ? this.schedule.periodEnd : now;
        this.schedule.periodDateId = !this.schedule.periodDate ? now : this.schedule.periodDate;

        console.log("schedule data", this.dataObj);
      });

    },
    setSelectedServiceType(value) {
      this.schedule.supportServiceType = this.supportServiceTypes.filter(p => p.value === value)[0].text;
      this.supportServiceType = this.supportServiceTypes.filter(p => p.value === value)[0];
      this.filterSupportServices();
    },
    setSelectedPeriodType(value) {
      this.support.periodType = this.periodTypes.filter(p => p.value === value)[0].text;
    },
    setSelectedUsageType(value) {
      this.schedule.usageType = this.usageTypes.filter(p => p.value === value)[0].text;
      this.filterSupportServices();
    },
    setSelectedTeam(value) {
      this.filterSupportServices();
    },
    setSelectedStation(value) {
      this.filterSupportServices();
    },
    filterSupportServices() {
      this.supportServices = this.supportServicesAll;

      if (this.teamId > -1)
        this.supportServices = this.supportServices.filter(p => p.teamId === this.teamId);
      if (this.stationId > -1)
        this.supportServices = this.supportServices.filter(p => p.stationId === this.stationId);
      if (this.schedule.supportServiceTypeId > -1)
        this.supportServices = this.supportServices.filter(p => p.supportServiceTypeId === parseInt(this.schedule.supportServiceTypeId));

    }
  },
}

